module.exports = __webpack_public_path__ + "8705ff0f458a10a97a4cf946e006480e.svg";